// extracted by css-extract-rspack-plugin
export default {"titleBox":"titleBox-uMD7F8"};